/* facebook pixel */
const sendFBPixelData = (event, products, params) => {
    if (typeof (fbq) !== 'undefined') {
        let content = {
            content_ids: products,
            content_type: 'product',
            currency: $('meta[name=currency]').attr('content')
        };
        params = typeof (params) === 'undefined' ? {} : params;
        params = Object.assign(content, params);

        console.log('track', event, params);
        fbq('track', event, params);
    }
}
const FBPixel = {
    viewContent: (id, params) => {
        sendFBPixelData('ViewContent', id, params);
    },
    addToCart: (id, params) => {
        sendFBPixelData('AddToCart', id, params);
    },
    initiateCheckout: (ids, params) => {
        sendFBPixelData('InitiateCheckout', ids, params);
    },
    purchase: (ids, params) => {
        sendFBPixelData('Purchase', ids, params);
    }
}
/* facebook pixel */

/* google analytics */
const sendGoogleAnalyticsData = (event, products, params, action) => {
    window.dataLayer = window.dataLayer || [];
    let content = {
        ecommerce: {
            currencyCode: $('meta[name=currency]').attr('content'),
            [event]: {
                products: products
            }
        },
        'event': 'gtm-ee-event',
    };
    if (typeof (action) !== 'undefined') {
        content.ecommerce[event].actionField = action;
    }
    params = typeof (params) === 'undefined' ? {} : params;
    content = Object.assign(content, params);
    console.log('dataLayer', content);
    window.dataLayer.push(content);
}
const GoogleAnalytics = {
    click: (item, url) => {
        sendGoogleAnalyticsData('click', [ item ], {'gtm-ee-event-category': 'Enhanced Ecommerce', 'gtm-ee-event-action': 'Product Clicks', 'gtm-ee-event-non-interaction': 'False'});
        if (typeof (url) !== 'undefined') {
            setTimeout(() => { document.location.href = url }, 200);
        }
    },
    detail: (item) => {
        sendGoogleAnalyticsData('detail', [ item ], {'gtm-ee-event-category': 'Enhanced Ecommerce', 'gtm-ee-event-action': 'Product Details', 'gtm-ee-event-non-interaction': 'False'});
    },
    purchase: (items, action) => {
        sendGoogleAnalyticsData('purchase', items, {'gtm-ee-event-category': 'Enhanced Ecommerce', 'gtm-ee-event-action': 'Purchase', 'gtm-ee-event-non-interaction': 'False'}, action);
    }
}
/* google analytics */

/* google ecommerce */
const sendECommerceData = (event, products, params) => {
    if (typeof (gtag) !== 'undefined' || typeof (ga) !== 'undefined') {
        window.dataLayer = window.dataLayer || [];
        let content = {
            items: products
        };
        params = typeof (params) === 'undefined' ? {} : params;
        params = Object.assign(content, params);
        console.log('dataLayer', {
            event: event,
            ecommerce: params
        });
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: event,
            ecommerce: params
        });
    }
}
const eCommerceProductList = (item) => {
    let container = $(item).closest('.fn_container').find('.fn_container_name'),
        breadcrumb = $('.breadcrumbs li:last'),
        product = $(item).find('.fn_product_name'),
        variant = $(item).find('input[name=variant]:checked'),
        category = product.data('category'),
        result = {},
        product_name = trimVal(product.text());

    product_name = product_name.length === 0 ? trimVal(product.attr('title')) : product_name;
    variant = variant.length === 0 ? $(item).find('input[name*=amounts]') : variant;
    variant = variant.length === 0 ? product : variant;
    result = {
        item_name: product_name,
        item_id: trimVal(variant.data('sku')),
        price: trimPrice(variant.data('price')),
        item_brand: trimVal(product.data('brand')),
        item_category: '',
        item_category2: '',
        item_category3: '',
        item_category4: '',
        item_variant: trimVal(variant.data('name')),
        item_list_name: container.length > 0 ? trimVal(container.text()) : (breadcrumb.length > 0 ? trimVal(breadcrumb.text()) : '')
    };
    if (typeof (category) !== 'undefined') {
        category.split(';').forEach((v, i) => {
            let key = (i > 0) ? (i + 1).toString() : '';
            result[`item_category${key}`] = trimVal(v);
        });
    }
    return result;
}
const eCommerceProduct = (item) => {
    let product = $(item),
        variant = $(item).find('input[name=variant]:checked'),
        category = $('.breadcrumbs li:not(:first):not(:last)'),
        result = {};

    result = {
        item_name: trimVal(product.find('h1').text()),
        item_id: trimVal(variant.data('sku')),
        price: trimPrice(variant.data('price')),
        item_brand: product.find('.fn_brand').length > 0 ? trimVal(product.find('.fn_brand').text()) : '',
        item_category: '',
        item_category2: '',
        item_category3: '',
        item_category4: '',
        item_variant: trimVal(variant.data('name')),
        index: 1,
        quantity: 1
    };
    if (typeof (category) !== 'undefined') {
        category.each((i, v) => {
            let key = (i > 0) ? (i + 1).toString() : '';
            result[`item_category${key}`] = trimVal($(v).text());
        });
    }
    return result;
}
const getPosition = (needle, search) => {
    let index, i = -1, elements = $(search);
    while (typeof (index) === 'undefined' && ++i < elements.length) {
        let element = elements[i];
        if ($(element).is(needle)) {
            index = i;
        }
    }
    index = typeof (index) === 'undefined' ? 0 : index;
    return index + 1;
}
const ECommerce = {
    view_item_list: () => {
        let items = [];
        $('.fn_product:visible').each((i, product) => {
            let canonical = $('link[rel=canonical]').attr('href');
            canonical = typeof (canonical) === 'undefined' ? window.location.href : canonical;
            canonical = canonical.replace(window.location.origin, '');
            if (i === 0 && canonical.indexOf('products') > -1 && canonical.indexOf('products') <= 4) {
                return true;
            }
            item = eCommerceProductList(product);
            item.index = items.length + 1;
            items.push(item);
        });
        if (items.length > 0) {
            sendECommerceData('view_item_list', items, { currency: $('meta[name=currency]').attr('content') });
        }
    },
    select_item: (item, url) => {
        sendECommerceData('select_item', [ item ], { currency: $('meta[name=currency]').attr('content') });
        if (typeof (url) !== 'undefined') {
            setTimeout(() => { document.location.href = url }, 200);
        }
    },
    view_item: (item) => {
        sendECommerceData('view_item', [ item ], { currency: $('meta[name=currency]').attr('content') });
    },
    add_to_cart: (item) => {
        sendECommerceData('add_to_cart', [ item ], { currency: $('meta[name=currency]').attr('content') });
    },
    remove_from_cart: (item) => {
        sendECommerceData('remove_from_cart', [ item ], { currency: $('meta[name=currency]').attr('content') });
    },
    view_cart: (items) => {
        sendECommerceData('view_cart', items, { currency: $('meta[name=currency]').attr('content') });
    },
    begin_checkout: (items) => {
        sendECommerceData('begin_checkout', items, { currency: $('meta[name=currency]').attr('content') });
    },
    add_shipping_info: (items, params) => {
        sendECommerceData('add_shipping_info', items, params);
    },
    add_payment_info: (items, params) => {
        sendECommerceData('add_payment_info', items, params);
    }
}
/* google ecommerce */

$(document).ready(function() {
    ECommerce.view_item_list();

    let canonical = $('link[rel=canonical]').attr('href');
    canonical = typeof (canonical) === 'undefined' ? window.location.href : canonical;
    canonical = canonical.replace(window.location.origin, '');

    if (canonical.indexOf('products') > -1 && canonical.indexOf('products') <= 4) {
        let product = $('.fn_product').first(),
            variant,
            product_name = $('.breadcrumbs li:last').text().replace(/\r?\n|\r/g, '').trim().substr(0, 100),
            category_name = $('.breadcrumbs li').length > 2 ? $('.breadcrumbs li:nth-last-child(2) a').text().substr(0, 100).trim() : '',
            brand_name = product.find('.fn_brand').text().trim();
        if (product.find('input[name=variant]:checked').length > 0) {
            variant = product.find('input[name=variant]:checked');
        } else {
            variant = product.find('input[name=variant]:first');
        }
        let variant_name = variant.siblings('label').text();
        FBPixel.viewContent([ variant.data('sku').toString().trim() ], {
            value: trimPrice(variant.data('price')),
            content_name: product_name,
            content_category: category_name
        });
        // GoogleAnalytics.detail({ id: variant.data('sku').toString().trim(), name: product_name, price: trimPrice(variant.data('price')), brand: brand_name, category: category_name, variant: variant_name });

        let item = eCommerceProduct(product);
        ECommerce.view_item(item);
    } else if (canonical.indexOf('cart') >= 1 && canonical.indexOf('cart') <= 4) {
        let ids = [], items = [], products_names = [], categories_names = [], amount = 0, price = 0.00, purchases = $('input[name*=amounts]:visible'),
            coupon = $('input[name=coupon_code]');
        if (purchases.length > 0) {
            purchases.each((i, v) => {
                ids.push($(v).data('sku').toString());
                amount = Math.max(1, parseInt($(v).val()));
                price += trimPrice($(v).data('price')) * amount;

                let product = $(v).closest('.purchase__item').find('.fn_product_name');
                let category_name = trimVal(product.data('category').split(';').slice(-1)[0]);
                let product_name = trimVal(product.text());
                product_name = product_name.length === 0 ? trimVal(product.attr('title')) : product_name;

                products_names.push(product_name);
                categories_names.push(category_name);

                let item = eCommerceProductList($(v).closest('.purchase__item'));
                item.quantity = amount;
                item.discount = $(v).data('discount');
                item.coupon = coupon.length > 0 ? coupon.val() : '';
                item.index = getPosition(v, $('.fn_purchases_wrap .purchase__item'));
                items.push(item);
            });
            FBPixel.initiateCheckout(ids, {
                value: trimPrice(price),
                content_name: products_names,
                content_category: categories_names,
                content_type: 'product_group',
                num_items: ids.length
            });
            ECommerce.view_cart(items);
        }

        $(document).on('click', '.fn_cart_checkout', function () {
            let form = $(this).closest('form'),
                step = $(this).data('next_step') - 1;
            form.find('.cart_delivery__checkout').removeClass('error');
            if (typeof (form.valid) !== 'function' || form.valid()) {
                let items = [], purchases = $('#fn_purchases .purchase__item');
                purchases.each((i, v) => {
                    let variant = $(v).find('input[name*=amounts]');
                    let item = eCommerceProductList($(variant).closest('.purchase__item'));
                    item.quantity = parseInt(variant.val());
                    items.push(item);
                });
                switch (step) {
                    case 1:
                        ECommerce.begin_checkout(items);
                        break;
                    case 2:
                        let delivery_name = getDelivery(form);
                        ECommerce.add_shipping_info(items, { shipping_tier: delivery_name });
                        window.sessionStorage.setItem('cartDeliveryId', delivery_name);
                        break;
                    case 3:
                }
            } else if (typeof (form.valid) === 'function' && !form.valid()) {
                let errors = form.validate().errorList;
                if (errors.length > 0) {
                    let error = errors[errors.length - 1];
                    let popup = $('#fn_cart_error');
                    if (popup.length === 1 && $(error.element).attr('type') === 'hidden') {
                        $(error.element).siblings('.cart_delivery__checkout').addClass('error');
                        popup.find('.popup__heading div').html(`<span>${error.message}</span>`);
                        $.fancybox.open({
                            src: popup,
                            type: 'inline',
                        });
                    }
                }
            }
        });

        const getDelivery = (form) => {
            let delivery = form.find('input[name=delivery_id]:checked'), delivery_name = [];
            if (delivery.siblings('.delivery__name').length > 0) {
                delivery_name.push(trimVal(delivery.siblings('.delivery__name').children().first().text()));
            }
            return trimVal(delivery_name.join(' '));
        }

        const getPaymentMethod = (form) => {
            let payment = form.find('input[name=payment_method_id]:checked'), payment_name = [];
            if (payment.siblings('.delivery__name').length > 0) {
                payment_name.push(trimVal(payment.siblings('.delivery__name').children().first().text()));
            }
            return trimVal(payment_name.join(' '));
        }

        $(document).on('change', 'input[name=delivery_id], .delivery input[name*=type]', function () {
            window.sessionStorage.removeItem('cartDeliveryId');
        });

        $(document).on('change', 'input[name=payment_method_id]', function () {
            window.sessionStorage.removeItem('cartPaymentId');
        });

        let fakeCheckout = true;
        $(document).on('submit', '.fn_validate_cart', function (e) {
            if (fakeCheckout === true) {
                if ((typeof (FBPixel) !== 'undefined' && typeof (FBPixel.purchase) === 'function')
                    || (typeof (ECommerce) !== 'undefined' && typeof (ECommerce.add_shipping_info) === 'function' || typeof (ECommerce.add_payment_info) === 'function')
                ) {
                    e.preventDefault();
                    const form = $(this);
                    if (form.valid() && purchases.length > 0) {
                        let ids = [], price = 0.00, items = [], products_names = [], categories_names = [], purchases = $(this).find('#fn_purchases .purchase__item');
                        purchases.each((i, v) => {
                            let variant = $(v).find('input[name*=amounts]');

                            ids.push(trimVal(variant.data('sku')));
                            price += trimPrice(variant.data('price')) * Math.max(1, parseInt(variant.val()));

                            // let product = $(v).closest('.purchase__item').find('.fn_product_name');
                            // let category_name = trimVal(product.data('category').split(';').slice(-1)[0]);
                            // let product_name = trimVal(product.text());
                            // product_name = product_name.length === 0 ? trimVal(product.attr('title')) : product_name;

                            // products_names.push(product_name);
                            // categories_names.push(category_name);

                            let item = eCommerceProductList($(variant).closest('.purchase__item'));
                            item.quantity = parseInt(variant.val());
                            items.push(item);
                        });

                        // if (typeof (FBPixel.purchase) === 'function') {
                        //     FBPixel.purchase(ids, {
                        //         value: trimPrice(price),
                        //         content_name: products_names,
                        //         content_category: categories_names,
                        //         content_type: 'product_group'
                        //     });
                        // }

                        if (typeof (ECommerce.add_shipping_info) === 'function' || typeof (ECommerce.add_payment_info) === 'function') {
                            if (typeof (ECommerce.add_shipping_info) === 'function' && null === window.sessionStorage.getItem('cartDeliveryId')) {
                                let delivery_name = getDelivery(form);
                                ECommerce.add_shipping_info(items, { shipping_tier: delivery_name, currency: $('meta[name=currency]').attr('content') });
                                window.sessionStorage.setItem('cartDeliveryId', delivery_name);
                            }
                            if (typeof (ECommerce.add_payment_info) === 'function') {
                                let payment_name = getPaymentMethod(form);
                                ECommerce.add_payment_info(items, { payment_type: payment_name, currency: $('meta[name=currency]').attr('content') });
                                window.sessionStorage.setItem('cartPaymentId', payment_name);
                            }
                            submitted_cart = false;
                            fakeCheckout = false;
                            setTimeout(() => {
                                window.sessionStorage.removeItem('cartDeliveryId');
                                window.sessionStorage.removeItem('cartPaymentId');
                                form.submit();
                            }, 1000);
                        }
                    }
                }
            }
        });

    } else if (canonical.indexOf('order') >= 1 && canonical.indexOf('order') <= 4) {
        let ids = [], products_names = [], categories_names = [], purchases, price = 0.00;
        if (typeof (window.FBPixelData) !== 'undefined') {
            purchases = window.FBPixelData;
            if (purchases.length > 0) {
                purchases.forEach((item) => {
                    ids.push(item.sku);
                    price += trimPrice(item.price);
                    products_names.push(item.name);
                    categories_names.push(item.category);
                });
                FBPixel.purchase(ids, {
                    value: trimPrice(price),
                    content_name: products_names,
                    content_category: categories_names,
                    content_type: 'product_group'
                });
            }
        }
        // if ($('.fn_order_checkout').length === 0) {
        //     if (typeof (window.ECommerceData) !== 'undefined') {
        //         let purchasesData = [], price = 0.00;
        //         purchases = window.ECommerceData;
        //         if (purchases.products.length > 0) {
        //             purchases.products.forEach((item) => {
        //                 price += trimPrice(item.price) * Math.max(1, parseInt(item.quantity));
        //                 purchasesData.push({
        //                     name: item.name,
        //                     price: item.price,
        //                     quantity: item.quantity
        //                 });
        //             });
        //         }
        //         GoogleAnalytics.purchase(purchasesData, { id: purchases.id, revenue: price});
        //     }
        // }
    }

    $(document).on('submit', '.fn_variants', function () {
        let price = 0.00, amount = 1, category, category_name, product, product_name, variant;
        if ($(this).closest('.fn_product').length > 0) {
            product = $(this).closest('.fn_product').first();
            variant = $(this).find('input[name=variant]:checked');
            if (variant.length > 0 && typeof (variant.val()) !== 'undefined') {
                amount = $(this).find('input[name=amount]').val() ? parseInt($(this).find('input[name=amount]').val()) : 1;
                price = trimPrice(variant.data('price'));
                if (canonical.indexOf('products') > -1 && canonical.indexOf('products') <= 4) {
                    product_name = trimVal(product.find('h1').text());
                    category = $('.breadcrumbs li:not(:first):not(:last)');
                    category_name = trimVal(category.text());
                } else {
                    product_name = trimVal($(product).find('.fn_product_name').text());
                    product_name = product_name.length === 0 ? trimVal($(product).find('.fn_product_name').attr('title')) : product_name;
                    category = product.find('.fn_product_name').data('category');
                    category_name = trimVal(category.split(';').slice(-1)[0]);
                }
                FBPixel.addToCart([ variant.data('sku').toString().trim() ], {
                    value: trimPrice(price) * parseInt(amount),
                    content_name: product_name,
                    content_category: category_name
                });

                if (canonical.indexOf('products') > -1 && canonical.indexOf('products') <= 4) {
                    let item;
                    if ($(this).closest('.fn_product').is('.fn_product:first')) {
                        item = eCommerceProduct($(this).closest('.fn_product'));
                        item.index = 1;
                    } else {
                        item = eCommerceProductList($(this).closest('.fn_product'));
                        item.index = getPosition($(this).closest('.fn_product'), $('.fn_product:not(:first)')) + 1;
                    }
                    item.quantity = Math.abs(amount);
                    ECommerce.add_to_cart(item);
                } else {
                    let item = eCommerceProductList($(this).closest('.fn_product'));
                    item.index = getPosition($(this).closest('.fn_product'), $('.fn_product'));
                    ECommerce.add_to_cart(item);
                }
            }
        }
    });

    $(document).on('change', 'input[name*=amounts]', function () {
        let amount = Math.min(parseInt($(this).val()) - parseInt($(this).data('amount')), parseInt($(this).data('max')) - 1);
        let action = amount > 0 ? 'add_to_cart' : 'remove_from_cart';
        let product = $(this).closest('.purchase__item');
        let item = eCommerceProductList(product);
        item.quantity = Math.abs(amount);
        if (item.quantity > 0) {
            item.index = getPosition(product, $('#fn_purchases .purchase__item'));
            if (typeof ECommerce[action] !== 'undefined') {
                ECommerce[action](item);
            }
        }
    });

    $(document).on('click', 'a.purchase__remove', function () {
        let product = $(this).closest('.purchase__item');
        let amount = parseInt(product.find('input[name*=amounts]').val());
        let item = eCommerceProductList(product);
        item.quantity = Math.abs(amount);
        if (item.quantity > 0) {
            item.index = getPosition(product, $('#fn_purchases .purchase__item'));
            ECommerce.remove_from_cart(item);
        }
    });

    if (window.location.pathname.indexOf('products') >= 1) {
            $(document).on('click', '.block .fn_product:has(a[href][data-product]) a:not([href*="#"])', function (e) {
            e.preventDefault();
            productClick($(this).closest('.fn_product'));
        });
    } else {
        $(document).on('click', '.fn_product:has(a[href][data-product]) a:not([href*="#"])', function (e) {
            e.preventDefault();
            productClick($(this).closest('.fn_product'));
        });
    }

    const productClick = (product) => {
        variant = product.find('input[name=variant]:checked');
        let url = product.find('a[href]').attr('href');
        // let product_name = product.find('a[data-product]').text(),
        //     variant_name,
        //     sku,
        //     price;
        // if (product_name.length === 0 && typeof (product.find('a[data-product]').attr('title')) !== 'undefined') {
        //     product_name = product.find('a[data-product]').attr('title');
        // }
        // product_name = product_name.replace(/\r?\n|\r/g, '').trim().substr(0, 100);
        // if (variant.length > 0) {
        //     variant_name = variant.siblings('label').text().toString().trim();
        //     sku = variant.data('sku').toString().trim();
        //     price = trimPrice(variant.data('price'));
        // } else {
        //     variant_name = product.find('a[data-product]').data('variant').toString().trim();
        //     sku = product.find('a[data-product]').data('sku').toString().trim();
        //     price = trimPrice(product.find('a[data-product]').data('price'));
        // }
        // let category_name = product.find('a[data-product]').data('category') !== 'undefined' ? product.find('a[data-product]').data('category').toString().trim() : product.find('a[data-product]').data('category').toString().trim();
        // let brand_name = product.find('a[data-product]').data('brand') !== 'undefined' ? product.find('a[data-product]').data('brand').toString().trim() : product.find('a[data-product]').data('brand').toString().trim();
        if (typeof (ECommerce.select_item) === 'function') {
            // GoogleAnalytics.click({ id: sku, name: product_name, price: price, brand: brand_name, category: category_name, variant: variant_name }, document.location.origin + '/' + url);
            let item = eCommerceProductList(product);
            if (canonical.indexOf('products') > -1 && canonical.indexOf('products') <= 4) {
                item.index = getPosition(product, $('.fn_product:has(a[href][data-product]):not(:first)'));
            } else {
                item.index = getPosition(product, $('.fn_product:has(a[href][data-product])'));
            }
            ECommerce.select_item(item, document.location.origin + '/' + url);
        } else {
            document.location = document.location.origin + '/' + url;
        }
    }
});

// function sendInitiateCheckout() {
//     let price = 0.00, amount = 1, product,
//         form = $("#fn_fast_order"),
//         variant_id = form.find('input[name=variant_id]').val(),
//         variant = $(`input[name=variant][value=${variant_id}]`);
//     if (variant.closest('.fn_product').length > 0 && variant.length > 0 && typeof (variant.val()) !== 'undefined') {
//         product = variant.closest('.fn_product').first();
//         price = trimPrice(variant.data('price'));
//         FBPixel.initiateCheckout(variant.data('sku').toString().trim(), {
//             value: trimPrice(price) * parseInt(amount)
//         });
//     }
// }

const trimVal = (val) => {
    val = typeof (val) === 'undefined' ? '' : val;
    return val.toString().replace(/\r?\n|\r/g, '').trim().substr(0, 100);
}

const trimPrice = (val) => {
    val = typeof (val) === 'undefined' ? '' : val;
    return parseFloat(val.toString().replace(/(,|\s)/g, '').trim());
}